import { ChevronDownIcon } from "@eworkit/iris";
import { changeLanguage, ILangOption, languagesList, TSupportedLanguageKey } from "i18n";
import React, { FC, memo } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";
import { useOnLanguageChange } from "@/hooks/Translations";
import { Actions } from "@/views/components/Actions";

import "./_language-switcher.scss";

export const LanguageSwitcher: FC = memo(() => {
  const currentLang = useOnLanguageChange();

  const selectLanguage = (lang: TSupportedLanguageKey) => () => {
    changeLanguage(lang);
  };

  const languages = Object.values(languagesList).sort((a, b) => (a.value < b.value ? -1 : 1));
  const [current] = languages.filter(l => l.code === currentLang);

  const renderTarget = () => {
    return (
      <Flex padding={["sm", false]} margin={["md", "md", "md", "sm"]} align="center" innerMargin="sm" direction="row">
        {current && <Icon icon="planet" color="grey1" size="lg" />}
        <Text size="lg" color="black">
          {current.value}
        </Text>
        <Flex padding={[true, "md"]}>
          <ChevronDownIcon color="n500" size="lg" />
        </Flex>
      </Flex>
    );
  };

  const renderOption = ({ code, value }: ILangOption) => (
    <div onClick={selectLanguage(code)} key={code}>
      <Flex
        direction="row"
        justify="space-between"
        className="language-switcher__item"
        padding={["sm"]}
        innerMargin="sm">
        <Flex>
          <Text color="black">{value}</Text>
        </Flex>
        <Flex>{current.code === code && <Icon icon="checkbox" size="md" color="vg500" />}</Flex>
      </Flex>
    </div>
  );

  return (
    <Actions renderTarget={renderTarget} className="language-switcher">
      <Flex padding={["xs", false]} direction="column">
        {languages.map(lang => renderOption(lang))}
      </Flex>
    </Actions>
  );
});
